import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/16/solid";

const ErrorMessage = ({message}) => {
  return (
    <div className="mb-4 p-4 text-whit bg-red-200 rounded">
      <div className="font-sans flex items-center gap-4">
        <ExclamationTriangleIcon className="size-5"/>
        {message}
      </div>
    </div>
  )
}

export default ErrorMessage;